import React, { useRef } from 'react';

import { defineCustomElement } from './rpf-global-nav/rpf-org-nav';

defineCustomElement();

export const RpfOrgNav = ({ ...props }) => {
  const rpfOrgNavRef = useRef(null);

  const refProps = {
    ...props
  };

  const {
    loggedIn,
    hideAccountDropdown,
    hideSignUp,
    hideLogIn,
    logInTokenUrl,
    signUpTokenUrl,
    logInPath,
    logOutPath,
    signUpPath,
    ...otherProps
  } = refProps;

  const propsInKebabCase = {
    'logged-in': loggedIn,
    'hide-account-dropdown': hideAccountDropdown,
    'hide-sign-up': hideSignUp,
    'hide-log-in': hideLogIn,
    'log-in-token-url':logInTokenUrl,
    'sign-up-token-url':signUpTokenUrl,
    'log-in-path':logInPath,
    'log-out-path':logOutPath,
    'sign-up-path':signUpPath,
    ...otherProps
  };

  return React.createElement('rpf-org-nav', { ref: rpfOrgNavRef, ...propsInKebabCase });
};
